import React from "react";
import { Field } from "formik";
import FormContainer from "forms/components/FormContainer";
import FormRow from "forms/components/FormRow";
import { CheckboxField, DropdownField, RenderTypeahead } from "forms/fields";
import orderBy from "lodash/orderBy";
import PropTypes from "prop-types";
import Lock from "rialto-icons/Lock";

import { Translate } from "utils";
import { isEmail } from "utils/validation";

const { t } = new Translate("DealForm");

const Tenant = (props) => {
  const {
    currentUserCompanyID,
    formik: {
      setFieldValue,
      values: { _tenantUndisclosed: isUndisclosed },
    },
    industries,
    isUndisclosable,
  } = props;

  const tenantSearchParameters = {
    facets: "related_company_ids",
    filters: `related_company_ids:${currentUserCompanyID}`,
  };
  const tenantContactSearchParameters = {
    facets: "related_company_ids",
    filters: `related_company_ids:${currentUserCompanyID}`,
  };
  const sortedIndustries = orderBy(industries, (industry) =>
    t(`industries.${industry}`).toLowerCase()
  );

  const selectTenant = (tenant) => setFieldValue("tenant", tenant);

  const selectTenantContact = (contact) => {
    setFieldValue("tenantContact", contact);
    setFieldValue("tenant", {
      name: contact.tenantName,
      industry: contact.tenantIndustry,
    });
  };

  const onReset = () => {
    setFieldValue("tenant", undefined);
    setFieldValue("tenantContact", undefined);
  };

  return (
    <FormContainer title={t("tenant.title")}>
      {isUndisclosable && (
        <FormRow>
          <Field component={CheckboxField} name="_tenantUndisclosed" onChange={onReset}>
            <Lock size="small" />
            <span dangerouslySetInnerHTML={{ __html: t("tenant.undisclose") }} />
          </Field>
        </FormRow>
      )}
      {!isUndisclosed && (
        <>
          <FormRow>
            <Field
              component={RenderTypeahead}
              label={t("name")}
              name="tenant.name"
              onSelect={selectTenant}
              searchIndex="Tenant"
              searchKey="name"
              searchParameters={tenantSearchParameters}
              autoFocus
            />
            <Field
              component={DropdownField}
              label={t("industry")}
              name="tenant.industry"
              valueExtractor={(industry) => t(`industries.${industry}`)}
              values={sortedIndustries}
            />
          </FormRow>
          <FormRow>
            <Field
              component={RenderTypeahead}
              label={t("fullName")}
              name="tenantContact.name"
              onSelect={selectTenantContact}
              searchIndex="TenantContact_by_name"
              searchKey="name"
              searchParameters={tenantContactSearchParameters}
            />
            <Field
              component={RenderTypeahead}
              label={t("email")}
              name="tenantContact.email"
              onSelect={selectTenantContact}
              searchIndex="TenantContact_by_email"
              searchKey="email"
              searchParameters={tenantContactSearchParameters}
              validate={isEmail}
            />
          </FormRow>
        </>
      )}
    </FormContainer>
  );
};

Tenant.propTypes = {
  currentUserCompanyID: PropTypes.number.isRequired,
  industries: PropTypes.arrayOf(PropTypes.string),
  isUndisclosable: PropTypes.bool,
  formik: PropTypes.shape({
    values: PropTypes.shape({
      _tenantUndisclosed: PropTypes.bool,
    }),
    setFieldValue: PropTypes.func,
  }),
};

export default Tenant;
